import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';

export enum SmartFixUIState {
  Chat,
  Feedback,
  Idle,
}

@Component({
  selector: 'smart-fix-image-hero',
  standalone: true,
  templateUrl: './smart-fix-image-hero.component.html',
  styleUrls: ['./smart-fix-image-hero.component.scss'],
  imports: [CommonModule],
})
export class SmartFixImageHeroComponent implements AfterViewInit {
  @Input({ required: true }) uiState!: SmartFixUIState;
  @Input() isOnMobile: boolean = false;
  @Output() transitionComplete = new EventEmitter<void>();
  public SmartFixUIState = SmartFixUIState;

  @ViewChild('introVideo', { static: false, read: ElementRef })
  introVideo!: ElementRef<HTMLVideoElement>;

  @ViewChild('transitionVideo', { static: false, read: ElementRef })
  transitionVideo!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit() {
    const smartFixHeroAnimation = this.introVideo.nativeElement;
    smartFixHeroAnimation.src = this.animationSrc('intro');
    this.setCommonVideoProps(smartFixHeroAnimation, true);
    smartFixHeroAnimation.load();
    smartFixHeroAnimation.play();
  }

  playTransition() {
    if (!this.transitionVideo) {
      console.error('transitionVideo is not defined');
      return;
    }

    const smartFixHeroTransitionAnimation = this.transitionVideo.nativeElement;
    smartFixHeroTransitionAnimation.currentTime = 0;
    smartFixHeroTransitionAnimation.src = this.animationSrc('transition');
    this.setCommonVideoProps(smartFixHeroTransitionAnimation, false);
    smartFixHeroTransitionAnimation.play();
  }

  onVideoEnded() {
    setTimeout(() => {
      this.transitionComplete.emit();
    }, 100);
  }

  animationSrc(type: 'intro' | 'transition'): string {
    const srcBase = '/assets/videos/';
    const deviceType = this.isOnMobile ? 'mobile' : 'desktop';
    return type === 'intro'
      ? `${srcBase}smart-fix-animation-${deviceType}.mp4`
      : `${srcBase}smart-fix-animation-transition-${deviceType}.mp4`;
  }

  setCommonVideoProps(video: HTMLVideoElement, loop = false) {
    video.muted = true;
    video.playsInline = true;
    video.loop = loop;
  }
}
